import { render, staticRenderFns } from "./LocalityInfo.vue?vue&type=template&id=8a99f1da&scoped=true"
import script from "./LocalityInfo.vue?vue&type=script&lang=js"
export * from "./LocalityInfo.vue?vue&type=script&lang=js"
import style0 from "./LocalityInfo.vue?vue&type=style&index=0&id=8a99f1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99f1da",
  null
  
)

export default component.exports